import {Graphics, Sprite, Text} from 'pixi.js';
import {TextFactory} from '../../../../../../factories/TextFactory';
import {Pivot} from '../../../../../../utils/Pivot';
import {ActiveData} from '../../../../../../data/ActiveData';
import {PlayerData} from '../../../../../../data/active_data/field_config/PlayerData';
import {PlayerDataEvent} from '../../../../../../data/active_data/field_config/player_data/PlayerDataEvent';

export class CardsCounter extends Sprite
{
    frontCard: Graphics;
    backCard: Graphics;
    valueText: Text;
    private playerData: PlayerData;

    constructor(private playerId: string) {
        super();

        this.frontCard = new Graphics();
        this.backCard = new Graphics();

        this.backCard.lineStyle(1, 0, .04);
        this.backCard.beginFill(0xffffff);
        this.backCard.drawRoundedRect(-19, -26, 38, 52, 5);
        this.backCard.endFill();
        this.backCard.rotation = Math.PI / 16;
        this.backCard.x = 5;

        this.valueText = TextFactory.create('', 24, 0);

        this.addChild(this.backCard);
        this.addChild(this.frontCard);
        this.addChild(this.valueText);

        this.playerData = ActiveData.root.getPlayerData(this.playerId);
        this.playerData.addListener(PlayerDataEvent.CARDS_COUNT_CHANGED, this.onCardsCountChanged, this);

        this.value = this.playerData.cardsCount;
    }

    set value(val: number) {
        this.valueText.text = val.toString();

        Pivot.centerPivot(this.valueText);
        this.drawFrontCard(Math.max(38, this.valueText.width + 10));
    }

    destroy(): void {
        this.playerData.addListener(PlayerDataEvent.CARDS_COUNT_CHANGED, this.onCardsCountChanged, this);
        super.destroy({children: true});
    }

    private onCardsCountChanged(cardsCount: number): void {
        this.value = cardsCount;
    }

    private drawFrontCard(width: number) {
        this.frontCard.clear();
        this.frontCard.lineStyle(1, 0, .04);
        this.frontCard.beginFill(0xffffff);
        this.frontCard.drawRoundedRect(-width / 2, -26, width, 52, 5);
        this.frontCard.endFill();
    }
}
